export const termConstants = {
    FETCH_REQUEST: 'TERM_FETCH_REQUEST',
    FETCH_SUCCESS: 'TERM_FETCH_SUCCESS',
    FETCH_FAILURE: 'TERM_FETCH_FAILURE',

    GET_REQUEST: 'TERM_GET_REQUEST',
    GET_SUCCESS: 'TERM_GET_SUCCESS',
    GET_FAILURE: 'TERM_GET_FAILURE',

    SAVE_REQUEST: 'TERM_SAVE_REQUEST',
    SAVE_SUCCESS: 'TERM_SAVE_SUCCESS',
    SAVE_FAILURE: 'TERM_SAVE_FAILURE',

    DELETE_REQUEST: 'TERM_DELETE_REQUEST',
    DELETE_SUCCESS: 'TERM_DELETE_SUCCESS',
    DELETE_FAILURE: 'TERM_DELETE_FAILURE',

    ACCEPTANCES_FETCH_REQUEST: 'TERM_ACCEPTANCES_FETCH_REQUEST',
    ACCEPTANCES_FETCH_SUCCESS: 'TERM_ACCEPTANCES_FETCH_SUCCESS',
    ACCEPTANCES_FETCH_FAILURE: 'TERM_ACCEPTANCES_FETCH_FAILURE',
};
